/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, string,  func,
} from 'prop-types';
import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';
import ClubSelectionDesktop from './ClubSelectionDesktop';
import ClubSelectionMobile from './ClubSelectionMobile';
import { selectedSkuType, skuDataType, UpsellType } from '../common/types';

const GraphqlClubSelection = ({
    skuData,
    selectedSku,
    renderSkuPrice,
    skuMonths,
    changeClubMonth,
    changeClubLength,
    tracker,
    clubUpsells,
    changeClubUpsell,
    selectedClubUpsells,
}) => (
    <DesktopMobile
        breakpoint={960}
        desktop={() => (
            <ClubSelectionDesktop
                skuData={skuData}
                selectedSku={selectedSku}
                renderSkuPrice={renderSkuPrice}
                skuMonths={skuMonths}
                changeClubMonth={changeClubMonth}
                changeClubLength={changeClubLength}
                tracker={tracker}
                clubUpsells={clubUpsells}
                changeClubUpsell={changeClubUpsell}
                selectedClubUpsells={selectedClubUpsells}
            />
        )}
        mobile={() => (
            <ClubSelectionMobile
                skuData={skuData}
                selectedSku={selectedSku}
                renderSkuPrice={renderSkuPrice}
                skuMonths={skuMonths}
                changeClubMonth={changeClubMonth}
                changeClubLength={changeClubLength}
                tracker={tracker}
                clubUpsells={clubUpsells}
                changeClubUpsell={changeClubUpsell}
                selectedClubUpsells={selectedClubUpsells}
            />
        )}
    />
);

GraphqlClubSelection.defaultProps = {
    renderSkuPrice: () => { },
    skuMonths: {},
    clubUpsells: [],
    changeClubMonth: () => { },
    tracker: () => { },
    changeClubLength: () => { },
    changeClubUpsell: () => {},
    selectedClubUpsells: null,
};

GraphqlClubSelection.propTypes = {
    renderSkuPrice: func,
    changeClubUpsell: func,
    changeClubMonth: func,
    skuData: skuDataType.isRequired,
    selectedSku: selectedSkuType.isRequired,
    skuMonths: object, // the object contains dynamic keys
    tracker: func,
    changeClubLength: func,
    selectedClubUpsells: string,
    clubUpsells: UpsellType,
};

export default (GraphqlClubSelection);
